import { __makeTemplateObject, __rest, __assign } from 'tslib';
import React__default from 'react';
import styled from 'styled-components';
import { typography } from '../../../node_modules/@xstyled/system/dist/xstyled-system.es.js';
import { shouldForwardProp } from '../../should-forward-prop.js';

var defaultStyles = {
  color: "darkMofo",
  fontFamily: "heading",
  fontSize: [0, 1],
  lineHeight: "1",
  fontWeight: "500"
};
var StyledLabel = /*#__PURE__*/styled("label").withConfig({
  shouldForwardProp: function (prop, defaultValidtorFn) {
    return shouldForwardProp(prop) && defaultValidtorFn(prop);
  },
  displayName: "Label__StyledLabel",
  componentId: "sc-nzud3e-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), typography);
var Label = function (_a) {
  var children = _a.children,
    rest = __rest(_a, ["children"]);
  return React__default.createElement(StyledLabel, __assign({}, defaultStyles, rest), children);
};
var templateObject_1;

export { Label, StyledLabel };
//# sourceMappingURL=Label.js.map
